let ___languageSsrConfig = {};

const getQueryVariable = function () {
  let queries = {};
  try {
    let search = window.location.search.match(/\?.*(?=\b|#)/);
    if (search) {
      search = search[0].replace(/^\?/, "");
    }
    if (search) {
      search.split('&').forEach((item) => {
        const param = item.split('=');
        if (param[1]) {
          queries[param[0]] = decodeURIComponent(param[1])
        }
      });
    }
    if (typeof window?.ssrConfig?.routerConfig?.short?.params === 'object' && !Array.isArray(window?.ssrConfig?.routerConfig?.short?.params)) {
      queries = Object.assign({}, queries, window.ssrConfig.routerConfig.short.params);
    }
    return queries;
  } catch (err) {
    console.log("整理参数失败: ", err);
    return {};
  }
}

try {
  //  将后端渲染的东西序列化成对象
  ___languageSsrConfig = typeof window.ssrConfig === 'string' ? JSON.parse(decodeURIComponent(window.ssrConfig)) : window.ssrConfig;
} catch (err) { }
const pageHeader = ___languageSsrConfig?.routerConfig?.pageHeader ?? {};
const subLanguage = str => {
  if (!str) {
    return 'en-US'
  }
  str = str.substring(0, 2)
  const obj = {
    en: 'en-US',
    km: 'km-KH',
    zh: 'zh-CN'
  }
  console.log('语种' + obj[str])
  return obj[str] || 'en-US'
  // return obj['km']
  // return obj['en']
  // return obj['zh']
}

let params = 'en'
if (pageHeader) {
  if (pageHeader.AcceptLanguage) params = pageHeader.AcceptLanguage
  if (pageHeader['accept-language']) params = pageHeader['accept-language']
} else if (navigator?.language) {
  params = navigator?.language
}

const _query = getQueryVariable()
if (_query.lang) params = _query.lang

export default {
  getPageHeaderCurrentLanguage: subLanguage(params)
}
